import react from "react";


const INITIALSTATE = {
    data: [],
    user: null,
    displayadd: false,
    company:[]
}

const UserReducer = (state = INITIALSTATE, action) => {
    switch (action.type) {
        case "SetSearchUserData":
            return { ...state, data: action.data };
        case "EditUser" :
            return { ...state, user: action.data };
        case "ShowAddUser" :
            return { ...state, displayadd: true };
        case "HideAddUser" :
            return { ...state, displayadd: false };
        case "SetUser" :
            return { ...state, user: action.data };
        case "SetCompany" :
            return { ...state, company: action.data };

        default: return state;
    };
}
export default UserReducer;